import H2 from '../components/Titles/h2';
import { ReactComponent as Step1Svg } from '../assets/icons/step1.svg';
import { ReactComponent as Step2Svg } from '../assets/icons/step2.svg';
import { ReactComponent as Step4Svg } from '../assets/icons/step4.svg';
import SvgImage from '../components/Images/svg';
import DescriptionSplit from '../components/Description/description-split';

export default function TitlePaymentLink({ title, description, step }) {
    return (
        <div className='px-4 md:px-0'>
            <H2 title={title} fontWeight='bold' theme='main' />

            <div className='flex mt-2 md:mt-5 flex-col md:flex-row'>
                <DescriptionSplit description={description} className='text-secondary w-full md:w-7/12' opacity='1' />

                <div className='w-full md:w-5/12 mt-3'>
                    <div className='flex justify-between md:justify-end items-center gap-3'>
                        <SvgImage
                            SvgComponent={Step1Svg}
                            alt="Step 1 Icon"
                            customHeight="28px"
                            customWidth="28px"
                            className="your-additional-classes"
                            color={Number(step) >= 1 ? "#1235E0" : "#c5c6c9"}
                        />

                        <div className="w-1/4 md:w-7 h-0.5 bg-gray-200 rounded" />

                        <SvgImage
                            SvgComponent={Step2Svg}
                            alt="Step 2 Icon"
                            customHeight="28px"
                            customWidth="28px"
                            className="your-additional-classes"
                            color={Number(step) >= 2 ? "#1235E0" : "#c5c6c9"}
                        />

                        <div className="w-1/4 md:w-7 h-0.5 bg-gray-200 rounded" />

                        <SvgImage
                            SvgComponent={Step4Svg}
                            alt="Step 4 Icon"
                            customHeight="28px"
                            customWidth="28px"
                            className="your-additional-classes"
                            color={Number(step) >= 3 ? "#1235E0" : "#c5c6c9"}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
};